/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as erc1155 from "./ERC1155";
export * as erc721 from "./ERC721";
